var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('dropdowninput',{attrs:{"title":_vm.title,"items":_vm.stringifiedItems,"required":_vm.required,"is-valid":_vm.isValid,"value":_vm.selected,"disabled":_vm.disabled},on:{"input":function($event){_vm.$emit('input', Number($event))}}})
}
var staticRenderFns = []

export { render, staticRenderFns }